<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px">
                    {{ $t("billing_mapping_role_access_create") }}
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                    style="display: flex; align-items: center">
                    <i
                      class="mdi mdi-restart"
                      style="font-size: 1.5rem; margin-right: 5px"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST">
                    <!-- role_name -->
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="role_name"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("role_name") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchRolesBilling"
                          v-model="forms.role_name"
                          label="name"
                          return-object
                          @search="asyncSearchRolesBilling"
                          :loading="isSearchingRoles"
                          :class="{
                            'is-invalid': errors.role_name,
                          }"></v-select>
                        <div v-if="errors.role_name">
                          <div class="alert alert-danger" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ errors.role_name[0] }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- warehouse -->
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="warehouse"
                          class="col-form-label"
                          style="padding-left: 25px">
                          {{ $t("warehouse") }}
                        </label>
                      </div>
                      <div class="col-lg-7">
                        <!-- Dropdown Search Warehouse -->
                        <v-select
                          v-model="selectedWarehouse"
                          :options="formattedWarehouseOptions"
                          label="formattedWarehouse"
                          return-object
                          @search="asyncSearchWarehouse"
                          :loading="isSearchingWarehouse"
                          :class="{
                            'is-invalid': errors.warehouse,
                          }"></v-select>
                        <table class="table table-bordered mt-3">
                          <thead>
                            <tr>
                              <th>{{ $t("warehouse_id") }}</th>
                              <th>{{ $t("warehouse_name") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="warehouse in selectedWarehouseList"
                              :key="warehouse.warehouseId"
                              :class="{ 'table-active': warehouse.selected }"
                              @click="toggleSelection(warehouse)">
                              <td>{{ warehouse.warehouseId }}</td>
                              <td>{{ warehouse.WarehouseDescr }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div v-if="errors.warehouse">
                          <div class="alert alert-danger" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ errors.warehouse[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2">
                        <!-- Toggle Select All/Unselect All button -->
                        <div class="row mr-5">
                          <button
                            class="btn d-flex align-items-center justify-content-center"
                            :class="
                              is_all_selected ? 'btn-secondary' : 'btn-info'
                            "
                            @click="toggle_select_all_unselect"
                            type="button"
                            :disabled="selectedWarehouseList.length === 0"
                            style="
                              height: 38px;
                              width: 38px;
                              margin-right: 10px;
                            ">
                            <i
                              :class="
                                is_all_selected
                                  ? 'mdi mdi-selection-ellipse-remove'
                                  : 'mdi mdi-selection-ellipse'
                              "
                              style="font-size: 1.5rem"></i>
                          </button>

                          <!-- Delete button styled to fit with dropdown height -->
                          <button
                            class="btn btn-danger d-flex align-items-center justify-content-center"
                            :disabled="
                              !is_delete_enabled_warehouse ||
                              selectedWarehouseList.length === 0
                            "
                            @click="delete_on_warehouse_checked"
                            type="button"
                            style="height: 38px; width: 38px">
                            <i
                              class="mdi mdi-delete-empty"
                              style="font-size: 1.5rem"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button">
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit">
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "RoleAccessAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      position: "up right",
      userData: "",
      userRole: "",
      permision_role: [],
      errors: [],
      fetchRolesBilling: [],
      fetchWarehouse: [],
      selectedWarehouseList: [],
      selectedWarehouse: null,
      isLoading: false,
      isSearchingRoles: false,
      isSearchingWarehouse: false,
      isAllSelected: false,
      is_all_selected: false,
      is_delete_enabled_warehouse: true,
      forms: {
        mapping_id: "",
        role_id: "",
        role_name: "",
        datas: "",
        created_at: "",
        updated_at: "",
        addwho: "",
        editwho: "",
      },
    };
  },
  computed: {
    formattedWarehouseOptions() {
      return this.fetchWarehouse.map((warehouse) => ({
        ...warehouse,
        formattedWarehouse: `${warehouse.warehouseId} - ${warehouse.WarehouseDescr}`,
      }));
    },
  },
  watch: {
    selectedWarehouse(newVal) {
      if (
        newVal &&
        !this.selectedWarehouseList.some(
          (warehouse) => warehouse.warehouseId === newVal.warehouseId
        )
      ) {
        this.selectedWarehouseList.push({
          ...newVal,
          selected: false, // Tambahkan properti 'selected' dengan default 'false'
        });
      }
    },

    "forms.role_name": {
      handler(newVal) {
        if (newVal && newVal.role_id) {
          this.forms.role_id = newVal.role_id; // Ambil role_id dari role_name yang dipilih
        }
      },
      immediate: true, // Jalankan sekali saat inisialisasi
    },
  },
  methods: {
    // NOTE part warehouse
    async loadWarehouse() {
      const baseURI = `${this.$settings.endPointBilling}dashboard/cml-billing/warehouse/get-data`;
      try {
        // Ambil data dari API
        const response = await this.$http.get(baseURI);

        // Atur fetchWarehouse dari data API
        if (response.data && response.data.datas && response.data.datas.data) {
          this.fetchWarehouse = response.data.datas.data;
        } else {
          console.error("Invalid response format for fetchWarehouse");
        }
      } catch (error) {
        // Penanganan error
        console.error("Error loading warehouse data:", error);
      }
    },

    async asyncSearchWarehouse(searchQuery) {
      this.isSearchingWarehouse = true;
      try {
        const baseURI = `${this.$settings.endPointBilling}dashboard/cml-billing/warehouse/get-data?search=${searchQuery}`;
        const response = await this.$http.get(baseURI);

        if (response.data && response.data.datas && response.data.datas.data) {
          this.fetchWarehouse = response.data.datas.data;
        }
      } catch (error) {
        console.error("Error searching warehouses:", error);
      } finally {
        this.isSearchingWarehouse = false;
      }
    },

    toggleSelection(warehouse) {
      warehouse.selected = !warehouse.selected;
      this.isAllSelected = this.selectedWarehouseList.every(
        (warehouse) => warehouse.selected
      );
    },

    removeSelectedWarehouses() {
      this.selectedWarehouseList = this.selectedWarehouseList.filter(
        (warehouse) => !warehouse.selected
      );
    },

    toggle_select_all_unselect() {
      this.is_all_selected = !this.is_all_selected;
      this.selectedWarehouseList.forEach((item) => {
        item.selected = this.is_all_selected;
      });
    },

    delete_on_warehouse_checked() {
      const deletedIds = this.selectedWarehouseList
        .filter((item) => item.selected)
        .map((item) => item.warehouseId);

      // Hapus warehouse yang dipilih dari `selectedWarehouseList`
      this.selectedWarehouseList = this.selectedWarehouseList.filter(
        (item) => !item.selected
      );

      // Pastikan `selectedWarehouse` tidak mengacu pada warehouse yang dihapus
      if (
        this.selectedWarehouse &&
        deletedIds.includes(this.selectedWarehouse.warehouseId)
      ) {
        this.selectedWarehouse = null;
      }
    },

    // NOTE part role_name
    loadRolesBilling() {
      const baseURI = `${this.$settings.endPoint}user/get-role-user-billing`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.fetchRolesBilling = response.data.datas;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    asyncSearchRolesBilling() {
      this.isSearchingRoles = true;
      const baseURI = `${this.$settings.endPoint}user/get-role-user-billing`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          // Pastikan role_id tersedia untuk setiap item
          this.fetchRolesBilling = response.data.datas.map((role) => ({
            role_id: role.role_id, // ID dari role
            name: role.name, // Nama untuk ditampilkan di dropdown
          }));
        })
        .finally(() => {
          this.isSearchingRoles = false;
        });
    },

    // NOTE part core
    submitDataOld() {
      this.isLoading = true;

      const baseURI =
        this.$settings.endPointBilling + "mapping/role-user-billing/create";
      this.$http
        .post(baseURI, this.forms, { timeout: 10000 })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.isLoading = false;
            window.location.href = "/billing-mapping/role-access/";
            this.success("Successfully Add");
          } else {
            this.isLoading = false;
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    submitData() {
      this.isLoading = true;
      this.errors = {}; // Reset errors

      // Validasi field role_id dan role_name menggunakan fungsi validateRequiredField
      this.validateRequiredField(
        "role_id",
        this.forms.role_id,
        this.$t("roleTxt")
      );
      this.validateRequiredField(
        "role_name",
        this.forms.role_name,
        this.$t("role_name")
      );

      // Validasi tabel warehouse, pastikan tidak kosong
      if (this.selectedWarehouseList.length === 0) {
        this.errors.warehouse = [this.$t("warehouse_empty_error")];
      } else {
        delete this.errors.warehouse; // Hapus error jika valid
      }

      // Jika ada error, hentikan eksekusi fungsi
      if (Object.keys(this.errors).length > 0) {
        this.isLoading = false;
        return;
      }

      // Siapkan data warehouse dalam format yang sesuai
      const warehouseData = this.selectedWarehouseList.map((warehouse) => ({
        warehouseId: warehouse.warehouseId,
        warehouseName: warehouse.WarehouseDescr,
      }));

      // Siapkan payload untuk dikirim
      const data = {
        role_id: this.forms.role_id,
        role_name: this.forms.role_name?.name || this.forms.role_name,
        datas: JSON.stringify({ warehouse: warehouseData }),
      };

      // Debug payload sebelum dikirim
      // console.log("Payload:", data);
      // this.isLoading = false;
      // return;

      // Submit data
      const baseURI =
        this.$settings.endPointBilling + "mapping/role-user-billing/create";

      this.$http
        .post(baseURI, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.success(response.data.datas.messages);
            window.location.href = "/billing-mapping/role-access/";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    // NOTE others & tools
    validateRequiredField(fieldName, fieldValue, translatedFieldName) {
      if (!fieldValue || (typeof fieldValue === "object" && !fieldValue.name)) {
        // Tambahkan pesan error jika tidak valid
        const errorMessage = `${translatedFieldName} is required`;
        this.$set(this.errors, fieldName, [errorMessage]);
      } else {
        // Hapus pesan error jika valid
        this.$delete(this.errors, fieldName);
      }
    },

    resetForm() {
      this.forms.role_id = "";
      this.forms.role_name = "";
      this.selectedWarehouseList = [];
      this.selectedWarehouse = null;
      this.fetchWarehouse = [];
      this.loadWarehouse();
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.userData = userDatas.sub;
      this.userRole = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MasterWarehouseCmlController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    backForm() {
      window.location.href = "/billing-mapping/role-access/";
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadRolesBilling();
    this.loadWarehouse();
  },
};
</script>
<style scoped></style>
